import { action } from 'typesafe-actions';
import {
  ILimitOrder,
  IDeleteLimitOrderPayload as BaseDeletePayload,
  IUpdateLimitOrderPayload as BaseUpdatePayload,
  ILimitOrdersResponse,
  ITicker,
  ILimitOrderPayload,
  enums,
} from '@kattana-io/common';

const entity = 'limit_orders';

export interface IDeleteLimitOrderPayload {
  data: BaseDeletePayload;
  token: string;
}

export interface IUpdateLimitOrderPayload {
  data: BaseUpdatePayload;
  token: string;
}

export interface IGetLimitOrdersPayload {
  wallet: string;
  token: string;
}

export interface ICreateLimitOrderPyload {
  payload: {
    address: string;
    payload: ILimitOrderPayload;
    chain_id: number;
  };
  executionType: enums.ExecutionType;
  callback: () => void;
}

const ACTION_GET_LIMIT_ORDERS = `${entity}/GET_LIMIT_ORDERS`;
const ACTION_CREATE_LIMIT_ORDER = `${entity}/CREATE_LIMIT_ORDER`;
const ACTION_ADD_LIMIT_ORDER = `${entity}/ADD_LIMIT_ORDER`;
const ACTION_SET_LIMIT_ORDERS = `${entity}/SET_LIMIT_ORDERS`;
const ACTION_SET_LIMIT_ORDERS_TICKERS = `${entity}/SET_LIMIT_ORDERS_TICKERS`;
const ACTION_DELETE_LIMIT_ORDER = `${entity}/DELETE_LIMIT_ORDER`;
const ACTION_DELETE_DONE_LIMIT_ORDER = `${entity}/DELETED_LIMIT_ORDER`;
const ACTION_TRIGGER_LIMIT_ORDER = `${entity}/TRIGGER_LIMIT_ORDER`;
const ACTION_CONSUME_LIMIT_ORDER = `${entity}/CONSUME_LIMIT_ORDER_VIEW`;
const ACTION_UPDATE_LIMIT_ORDER_PRICE = `${entity}/UPDATE_LIMIT_ORDER_PRICE`;
const ACTION_AFTER_UPDATE_LIMIT_ORDER = `${entity}/AFTER_UPDATE_LIMIT_ORDER_PRICE`;
const ACTION_SET_CREATING_LIMIT_ORDERS = `${entity}/SET_CREATING_FLAG`;

const actionGetLimitOrders = (payload: IGetLimitOrdersPayload) =>
  action(ACTION_GET_LIMIT_ORDERS, payload);
const actionCreateLimitOrder = (payload: ICreateLimitOrderPyload) =>
  action(ACTION_CREATE_LIMIT_ORDER, payload);
const actionSetCreatingLimitOrders = (payload: boolean) =>
  action(ACTION_SET_CREATING_LIMIT_ORDERS, payload);
const actionSetLimitOrders = (orders: ILimitOrdersResponse) =>
  action(ACTION_SET_LIMIT_ORDERS, orders);
const actionSetLimitOrdersTickers = (tickers: Record<string, ITicker>) =>
  action(ACTION_SET_LIMIT_ORDERS_TICKERS, tickers);
const actionAddLimitOrder = (payload: ILimitOrder) =>
  action(ACTION_ADD_LIMIT_ORDER, payload);
const actionDeleteLimitOrder = (payload: IDeleteLimitOrderPayload) =>
  action(ACTION_DELETE_LIMIT_ORDER, payload);
const actionDeletedLimitOrder = (payload: IDeleteLimitOrderPayload) =>
  action(ACTION_DELETE_DONE_LIMIT_ORDER, payload);
const actionTriggerLimitOrder = (payload: ILimitOrder) =>
  action(ACTION_TRIGGER_LIMIT_ORDER, payload);
const actionConsumeLimitOrder = (payload: ILimitOrder) =>
  action(ACTION_CONSUME_LIMIT_ORDER, payload);
const actionUpdateLimitOrderPrice = (payload: IUpdateLimitOrderPayload) =>
  action(ACTION_UPDATE_LIMIT_ORDER_PRICE, payload);
const actionAfterUpdateLimitOrderPrice = (payload: IUpdateLimitOrderPayload) =>
  action(ACTION_AFTER_UPDATE_LIMIT_ORDER, payload);

export {
  ACTION_GET_LIMIT_ORDERS,
  ACTION_CREATE_LIMIT_ORDER,
  ACTION_ADD_LIMIT_ORDER,
  ACTION_SET_LIMIT_ORDERS,
  ACTION_SET_LIMIT_ORDERS_TICKERS,
  ACTION_DELETE_LIMIT_ORDER,
  ACTION_DELETE_DONE_LIMIT_ORDER,
  ACTION_TRIGGER_LIMIT_ORDER,
  ACTION_CONSUME_LIMIT_ORDER,
  ACTION_UPDATE_LIMIT_ORDER_PRICE,
  ACTION_AFTER_UPDATE_LIMIT_ORDER,
  ACTION_SET_CREATING_LIMIT_ORDERS,
  actionGetLimitOrders,
  actionCreateLimitOrder,
  actionSetLimitOrders,
  actionSetLimitOrdersTickers,
  actionDeleteLimitOrder,
  actionDeletedLimitOrder,
  actionTriggerLimitOrder,
  actionConsumeLimitOrder,
  actionUpdateLimitOrderPrice,
  actionAfterUpdateLimitOrderPrice,
  actionSetCreatingLimitOrders,
  actionAddLimitOrder,
};
